import { Component, OnInit } from '@angular/core';
import { AutomationService, AutomationProductValidation } from '../../../service/automation.service';

@Component({
  selector: 'app-automation-validation',
  standalone: false,
  templateUrl: './automation-validation.component.html',
  styleUrls: ['./automation-validation.component.scss'],
})
export class AutomationValidationComponent implements OnInit {
  validations: AutomationProductValidation[] = [];
  loading = true;
  selectedIds: Set<number> = new Set();
  viewMode: 'desk' | 'mob' = 'desk';

  constructor(private automationService: AutomationService) {}

  ngOnInit(): void {
    this.loadValidations();
  }

  loadValidations(): void {
    this.loading = true;
    this.automationService.getPendingValidations().subscribe({
      next: (validations) => {
        this.validations = validations;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  toggleSelection(id: number): void {
    if (this.selectedIds.has(id)) {
      this.selectedIds.delete(id);
    } else {
      this.selectedIds.add(id);
    }
  }

  selectAll(): void {
    this.validations.forEach((v) => this.selectedIds.add(v.id));
  }

  deselectAll(): void {
    this.selectedIds.clear();
  }

  approveSelected(): void {
    const ids = Array.from(this.selectedIds);
    if (ids.length === 0) return;

    const approvedIds = new Set(ids);
    this.automationService.bulkApprove(ids).subscribe({
      next: () => {
        this.validations = this.validations.filter((v) => !approvedIds.has(v.id));
        this.selectedIds.clear();
      },
      error: () => {
        // API call failed — keep items visible in the UI
      },
    });
  }

  approveSingle(validation: AutomationProductValidation): void {
    this.automationService.approveValidation(validation.id).subscribe(() => {
      this.validations = this.validations.filter((v) => v.id !== validation.id);
      this.selectedIds.delete(validation.id);
    });
  }

  rejectSingle(validation: AutomationProductValidation): void {
    this.automationService.rejectValidation(validation.id).subscribe(() => {
      this.validations = this.validations.filter((v) => v.id !== validation.id);
      this.selectedIds.delete(validation.id);
    });
  }

  getImageUrl(validation: AutomationProductValidation): string {
    return this.viewMode === 'desk' ? validation.url_desk : validation.url_mob;
  }
}
